import { render, staticRenderFns } from "./Tft.vue?vue&type=template&id=921e91fa&scoped=true"
import script from "./Tft.vue?vue&type=script&lang=js"
export * from "./Tft.vue?vue&type=script&lang=js"
import style0 from "./Tft.vue?vue&type=style&index=0&id=921e91fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "921e91fa",
  null
  
)

export default component.exports